// extracted by mini-css-extract-plugin
export default {"scrollbar-shift":"scrollbar-shift__e0566c"};